if (!customElements.get('platane-hot-showcase')) {
  customElements.define('platane-hot-showcase', class PlataneHotShowcase extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.viewport = this.querySelector('[data-hot-viewport]');
      this.items = Array.from(this.querySelectorAll('[data-hot-item]'));
      const scope = this.closest('section') || this;
      this.previousButton = scope.querySelector('[data-hot-previous]');
      this.nextButton = scope.querySelector('[data-hot-next]');
      this.dotsContainer = this.querySelector('[data-hot-dots]');
      this.currentPage = 0;

      if (!this.viewport || this.items.length === 0) return;

      this.previousButton?.addEventListener('click', () => this.goTo(this.currentPage - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.currentPage + 1));
      this.dotsContainer?.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-hot-dot]');
        if (dot) this.goTo(Number(dot.dataset.hotDot));
      });
      this.viewport.addEventListener('scroll', () => this.onScroll(), { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.viewport);
      } else {
        this.handleResize = () => this.update();
        window.addEventListener('resize', this.handleResize, { passive: true });
      }
      this.update();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      if (this.handleResize) window.removeEventListener('resize', this.handleResize);
      window.cancelAnimationFrame(this.scrollFrame);
    }

    // 每屏可见数量：用第 1 个 item 的 offsetLeft 计算（含 gap）
    get visibleCount() {
      if (!this.items[0]) return 1;
      const step = this.items.length > 1 ? this.items[1].offsetLeft - this.items[0].offsetLeft : this.items[0].getBoundingClientRect().width;
      if (step <= 0) return 1;
      return Math.max(1, Math.round(this.viewport.clientWidth / step));
    }

    get pageCount() {
      return Math.max(1, Math.ceil(this.items.length / this.visibleCount));
    }

    get maxScroll() {
      return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    }

    update() {
      this.currentPage = Math.min(this.currentPage, this.pageCount - 1);
      if (this.items[0]) {
        // 更新箭头禁用态
        this.previousButton?.toggleAttribute('disabled', this.currentPage <= 0);
        this.nextButton?.toggleAttribute('disabled', this.currentPage >= this.pageCount - 1);
      }
      this.renderDots();
    }

    renderDots() {
      if (!this.dotsContainer) return;
      const count = this.pageCount;
      if (count <= 1) {
        this.dotsContainer.innerHTML = '';
        return;
      }
      let html = '';
      for (let i = 0; i < count; i++) {
        const active = i === this.currentPage ? ' pl-hot-showcase__dot--active' : '';
        html += '<button type="button" class="pl-hot-showcase__dot' + active + '" data-hot-dot="' + i + '" role="tab" aria-label="Page ' + (i + 1) + '" aria-selected="' + (i === this.currentPage) + '"></button>';
      }
      if (this.dotsContainer.innerHTML !== html) {
        this.dotsContainer.innerHTML = html;
      }
    }

    goTo(page) {
      const count = this.pageCount;
      this.currentPage = (page + count) % count;
      // 计算目标：当前页首 item 相对 viewport 的偏移
      const item = this.items[this.currentPage * this.visibleCount];
      let target = 0;
      if (item) {
        target = item.offsetLeft - this.viewport.offsetLeft;
      } else {
        target = this.maxScroll;
      }
      target = Math.max(0, Math.min(this.maxScroll, target));
      this.viewport.scrollTo({
        left: target,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
      this.update();
    }

    onScroll() {
      window.cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = window.requestAnimationFrame(() => {
        if (!this.viewport.clientWidth) return;
        // 按滚动位置估算当前页
        const max = this.maxScroll;
        if (max <= 1) {
          this.currentPage = 0;
        } else {
          this.currentPage = Math.min(
            this.pageCount - 1,
            Math.round(this.viewport.scrollLeft / max * (this.pageCount - 1))
          );
        }
        this.update();
      });
    }
  });
}
